import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "65",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  d: "M24 19.167V8.5h16v10.667m10.133 0H13.867c-2.987 0-4.48 0-5.622.581a5.33 5.33 0 0 0-2.33 2.33c-.582 1.142-.582 2.635-.582 5.622v20.267c0 2.987 0 4.48.581 5.62a5.33 5.33 0 0 0 2.331 2.332c1.141.581 2.635.581 5.622.581h36.266c2.987 0 4.48 0 5.621-.581a5.33 5.33 0 0 0 2.331-2.331c.581-1.14.581-2.634.581-5.621V27.7c0-2.987 0-4.48-.58-5.621a5.33 5.33 0 0 0-2.331-2.331c-1.141-.581-2.635-.581-5.622-.581"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }